import { render } from "./doctor.signup.modal.vue?vue&type=template&id=72bda446&ts=true"
import script from "./doctor.signup.modal.vue?vue&type=script&lang=ts"
export * from "./doctor.signup.modal.vue?vue&type=script&lang=ts"

import "./doctor.signup.modal.vue?vue&type=style&index=0&id=72bda446&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__